// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CreateDilPayloadApiModel$PorterinFeature from "../api-model/CreateDilPayloadApiModel.mjs";

var execute = CreateDilPayloadApiModel$PorterinFeature.t_encode;

export {
  execute ,
}
/* No side effect */
